import { render, staticRenderFns } from "./shelfView.vue?vue&type=template&id=e85575ea&scoped=true"
import script from "./shelfView.vue?vue&type=script&lang=js"
export * from "./shelfView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e85575ea",
  null
  
)

export default component.exports